export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/boost-banner/BoostBanner.tsx"